import { useState } from 'react';
import packageJson from '../../../package.json';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import LoginForm from './LoginForm';
import { useAuth } from '../../hooks/useAuth';
import styles from './Login.module.scss';
import { useEffect } from 'react';
import { isValidSession } from '../../utils';
import { useTranslation } from 'react-i18next';
import useBmsVersion from '../BMSLabelling/useBmsVersion';
import UnsupportedBrowserWarning from '~/components/UnsupportedBrowserWarning';
import ResolutionBlocker from '~/components/ResolutionBlocker';

export default function Login() {
  const [devLogin, setDevLogin] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const { session } = useAuth();
  const { t } = useTranslation();
  const bmsVersion = useBmsVersion();

  useEffect(() => {
    if (isValidSession(session)) {
      navigate('/');
    }
  }, [navigate, session]);

  const message = location?.state?.message;

  return (
    <>
      <UnsupportedBrowserWarning />
      <ResolutionBlocker minWidth={1280} minHeight={720} />
      <div className={styles.logo}></div>
      <section className={styles.loginCenterContent}>
        <div>
          <LoginForm devMode={devLogin} message={message} />
        </div>
      </section>
      <footer className={styles.loginFooter}>
        <strong>Friska AB</strong>
        <span>{t('page.login.footer.address')}</span>
        <div className={styles.version}>
          {bmsVersion?.data?.version && <Link to="/bms">{bmsVersion.data.version}</Link>}
          <span onClick={import.meta.env.VITE_ENV !== 'production' ? () => setDevLogin(!devLogin) : undefined}>
            {bmsVersion?.data?.version ? ' - ' : ''}
            Partnerportalen: {packageJson.version}
          </span>
        </div>
      </footer>
    </>
  );
}
